// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Base ── */
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Segoe UI', Arial, sans-serif;
  color: #1a2b4a;
}

/* ── Hero / Main content rows ── */
.main-content {
  display: flex;
  align-items: center;
  gap: 48px;
  padding: 64px 80px;
  background-color: #ffffff;
}

.main-content.alt-bg {
  background-color: #f4f8fb;
}

.main-content.accent-bg {
  background-color: #1a2b4a;
  color: #ffffff;
}

.main-content.accent-bg p {
  color: #cdd8e8;
}

.text-content {
  flex: 1 1;
}

.text-content h1 {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.25;
  margin-bottom: 16px;
  color: inherit;
}

.text-content h2 {
  font-size: 1.6rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: inherit;
}

.text-content p {
  font-size: 1.05rem;
  line-height: 1.75;
  color: #3d5068;
}

.text-content ol {
  padding-left: 20px;
}

.text-content ol li {
  font-size: 1rem;
  line-height: 1.7;
  color: #3d5068;
  margin-bottom: 4px;
}

.image-content {
  flex: 1 1;
  display: flex;
  justify-content: center;
}

.image-content img {
  width: 100%;
  max-width: 480px;
  border-radius: 12px;
  object-fit: cover;
  box-shadow: 0 8px 28px rgba(0,0,0,0.1);
}

/* ── Hero section ── */
.hero-section {
  display: flex;
  align-items: center;
  gap: 48px;
  padding: 80px 80px 64px;
  background: linear-gradient(135deg, #f4f8fb 60%, #e0f2ec 100%);
}

.hero-section .text-content h1 {
  font-size: 2.4rem;
}

.hero-badge {
  display: inline-block;
  background-color: #e0f2ec;
  color: #1a8a6a;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 5px 12px;
  border-radius: 20px;
  margin-bottom: 14px;
}

.hero-actions {
  display: flex;
  gap: 14px;
  margin-top: 28px;
  flex-wrap: wrap;
}

.btn-primary {
  background-color: #4fc3a1;
  color: #1a2b4a;
  font-weight: 700;
  font-size: 0.95rem;
  padding: 12px 28px;
  border-radius: 8px;
  text-decoration: none;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #3aae8c;
  color: #fff;
}

.btn-secondary {
  background-color: transparent;
  color: #1a2b4a;
  font-weight: 600;
  font-size: 0.95rem;
  padding: 12px 28px;
  border-radius: 8px;
  text-decoration: none;
  border: 2px solid #1a2b4a;
  transition: background-color 0.2s, color 0.2s;
}

.btn-secondary:hover {
  background-color: #1a2b4a;
  color: #fff;
}

/* ── Stats bar ── */
.stats-bar {
  display: flex;
  justify-content: space-around;
  background-color: #1a2b4a;
  padding: 36px 80px;
  gap: 24px;
}

.stat-item {
  text-align: center;
  color: #fff;
}

.stat-number {
  font-size: 2rem;
  font-weight: 800;
  color: #4fc3a1;
  display: block;
}

.stat-label {
  font-size: 0.85rem;
  color: #cdd8e8;
  margin-top: 4px;
}

/* ── Frameworks grid ── */
.frameworks-section {
  padding: 64px 80px;
  background-color: #f4f8fb;
  text-align: center;
}

.frameworks-section h2 {
  font-size: 1.6rem;
  font-weight: 700;
  margin-bottom: 8px;
  color: #1a2b4a;
}

.frameworks-section .subtitle {
  font-size: 1rem;
  color: #5a7085;
  margin-bottom: 40px;
}

.frameworks-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
}

.framework-badge {
  background-color: #fff;
  border: 1.5px solid #d0dce8;
  border-radius: 8px;
  padding: 14px 24px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #1a2b4a;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.framework-badge:hover {
  border-color: #4fc3a1;
  box-shadow: 0 4px 12px rgba(79,195,161,0.15);
}

/* ── CTA section ── */
.cta-section {
  /*background-color: #1a2b4a;*/
  background-color: #e6eef3;
  padding: 72px 80px;
  text-align: center;
  color: #000;
}

.cta-section h1 {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 16px;
}

.cta-section p {
  font-size: 1.05rem;
  /*color: #cdd8e8; */
  color: #3d5068;
  max-width: 600px;
  margin: 0 auto 32px;
  line-height: 1.75;
}

/* ── Contact section ── */
.contact-section {
  max-width: 520px;
}

.contact-section h2 {
  font-size: 1.7rem;
  margin-bottom: 12px;
}

.contact-section p {
  font-size: 1rem;
  line-height: 1.75;
  color: #3d5068;
  margin-bottom: 6px;
}

.contact-details {
  margin-top: 20px;
  background-color: #f4f8fb;
  border-radius: 10px;
  padding: 20px 24px;
  border-left: 4px solid #4fc3a1;
}

.contact-details p {
  margin: 6px 0;
  font-size: 0.97rem;
  color: #1a2b4a;
}

.contact-details a {
  color: #1a8a6a;
  text-decoration: none;
  font-weight: 600;
}

.contact-details a:hover {
  text-decoration: underline;
}

/* ── Footer ── */
.footer {
  background-color: #111e33; 
  /*color: #aab8c8; */
  color:#fffff;
  text-align: center;
  padding: 40px 40px 24px;
  font-size: 0.88rem;
  line-height: 1.7;
}

.footer h4 {
  color: #ffffff;
  font-size: 0.95rem;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.footer p {
  margin: 4px 0;
  color: #ffffff;
}

.footer .Policy {
  margin-top: 12px;
  margin-bottom: 12px;
}

.footer .Policy a {
  color: #aab8c8;
  text-decoration: none;
  margin: 0 8px;
  font-weight: 600;
  transition: color 0.2s;
}

.footer .Policy a:hover {
  color: #4fc3a1;
}

/* ── Responsive ── */
@media (max-width: 900px) {
  .main-content,
  .hero-section {
    flex-direction: column;
    padding: 48px 28px;
    gap: 32px;
  }

  .main-content.alt-bg .image-content {
    order: -1;
  }

  .text-content h1 {
    font-size: 1.55rem;
  }

  .hero-section .text-content h1 {
    font-size: 1.75rem;
  }

  .stats-bar {
    flex-wrap: wrap;
    padding: 32px 24px;
    gap: 28px;
  }

  .frameworks-section {
    padding: 48px 24px;
  }

  .cta-section {
    padding: 56px 28px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/home.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,8DAA8D;AAChE;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE;;IAEE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* ── Base ── */\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Segoe UI', Arial, sans-serif;\n  color: #1a2b4a;\n}\n\n/* ── Hero / Main content rows ── */\n.main-content {\n  display: flex;\n  align-items: center;\n  gap: 48px;\n  padding: 64px 80px;\n  background-color: #ffffff;\n}\n\n.main-content.alt-bg {\n  background-color: #f4f8fb;\n}\n\n.main-content.accent-bg {\n  background-color: #1a2b4a;\n  color: #ffffff;\n}\n\n.main-content.accent-bg p {\n  color: #cdd8e8;\n}\n\n.text-content {\n  flex: 1;\n}\n\n.text-content h1 {\n  font-size: 2rem;\n  font-weight: 700;\n  line-height: 1.25;\n  margin-bottom: 16px;\n  color: inherit;\n}\n\n.text-content h2 {\n  font-size: 1.6rem;\n  font-weight: 700;\n  margin-bottom: 12px;\n  color: inherit;\n}\n\n.text-content p {\n  font-size: 1.05rem;\n  line-height: 1.75;\n  color: #3d5068;\n}\n\n.text-content ol {\n  padding-left: 20px;\n}\n\n.text-content ol li {\n  font-size: 1rem;\n  line-height: 1.7;\n  color: #3d5068;\n  margin-bottom: 4px;\n}\n\n.image-content {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n}\n\n.image-content img {\n  width: 100%;\n  max-width: 480px;\n  border-radius: 12px;\n  object-fit: cover;\n  box-shadow: 0 8px 28px rgba(0,0,0,0.1);\n}\n\n/* ── Hero section ── */\n.hero-section {\n  display: flex;\n  align-items: center;\n  gap: 48px;\n  padding: 80px 80px 64px;\n  background: linear-gradient(135deg, #f4f8fb 60%, #e0f2ec 100%);\n}\n\n.hero-section .text-content h1 {\n  font-size: 2.4rem;\n}\n\n.hero-badge {\n  display: inline-block;\n  background-color: #e0f2ec;\n  color: #1a8a6a;\n  font-size: 0.8rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  padding: 5px 12px;\n  border-radius: 20px;\n  margin-bottom: 14px;\n}\n\n.hero-actions {\n  display: flex;\n  gap: 14px;\n  margin-top: 28px;\n  flex-wrap: wrap;\n}\n\n.btn-primary {\n  background-color: #4fc3a1;\n  color: #1a2b4a;\n  font-weight: 700;\n  font-size: 0.95rem;\n  padding: 12px 28px;\n  border-radius: 8px;\n  text-decoration: none;\n  transition: background-color 0.2s;\n}\n\n.btn-primary:hover {\n  background-color: #3aae8c;\n  color: #fff;\n}\n\n.btn-secondary {\n  background-color: transparent;\n  color: #1a2b4a;\n  font-weight: 600;\n  font-size: 0.95rem;\n  padding: 12px 28px;\n  border-radius: 8px;\n  text-decoration: none;\n  border: 2px solid #1a2b4a;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.btn-secondary:hover {\n  background-color: #1a2b4a;\n  color: #fff;\n}\n\n/* ── Stats bar ── */\n.stats-bar {\n  display: flex;\n  justify-content: space-around;\n  background-color: #1a2b4a;\n  padding: 36px 80px;\n  gap: 24px;\n}\n\n.stat-item {\n  text-align: center;\n  color: #fff;\n}\n\n.stat-number {\n  font-size: 2rem;\n  font-weight: 800;\n  color: #4fc3a1;\n  display: block;\n}\n\n.stat-label {\n  font-size: 0.85rem;\n  color: #cdd8e8;\n  margin-top: 4px;\n}\n\n/* ── Frameworks grid ── */\n.frameworks-section {\n  padding: 64px 80px;\n  background-color: #f4f8fb;\n  text-align: center;\n}\n\n.frameworks-section h2 {\n  font-size: 1.6rem;\n  font-weight: 700;\n  margin-bottom: 8px;\n  color: #1a2b4a;\n}\n\n.frameworks-section .subtitle {\n  font-size: 1rem;\n  color: #5a7085;\n  margin-bottom: 40px;\n}\n\n.frameworks-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  justify-content: center;\n}\n\n.framework-badge {\n  background-color: #fff;\n  border: 1.5px solid #d0dce8;\n  border-radius: 8px;\n  padding: 14px 24px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #1a2b4a;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.framework-badge:hover {\n  border-color: #4fc3a1;\n  box-shadow: 0 4px 12px rgba(79,195,161,0.15);\n}\n\n/* ── CTA section ── */\n.cta-section {\n  /*background-color: #1a2b4a;*/\n  background-color: #e6eef3;\n  padding: 72px 80px;\n  text-align: center;\n  color: #000;\n}\n\n.cta-section h1 {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 16px;\n}\n\n.cta-section p {\n  font-size: 1.05rem;\n  /*color: #cdd8e8; */\n  color: #3d5068;\n  max-width: 600px;\n  margin: 0 auto 32px;\n  line-height: 1.75;\n}\n\n/* ── Contact section ── */\n.contact-section {\n  max-width: 520px;\n}\n\n.contact-section h2 {\n  font-size: 1.7rem;\n  margin-bottom: 12px;\n}\n\n.contact-section p {\n  font-size: 1rem;\n  line-height: 1.75;\n  color: #3d5068;\n  margin-bottom: 6px;\n}\n\n.contact-details {\n  margin-top: 20px;\n  background-color: #f4f8fb;\n  border-radius: 10px;\n  padding: 20px 24px;\n  border-left: 4px solid #4fc3a1;\n}\n\n.contact-details p {\n  margin: 6px 0;\n  font-size: 0.97rem;\n  color: #1a2b4a;\n}\n\n.contact-details a {\n  color: #1a8a6a;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.contact-details a:hover {\n  text-decoration: underline;\n}\n\n/* ── Footer ── */\n.footer {\n  background-color: #111e33; \n  /*color: #aab8c8; */\n  color:#fffff;\n  text-align: center;\n  padding: 40px 40px 24px;\n  font-size: 0.88rem;\n  line-height: 1.7;\n}\n\n.footer h4 {\n  color: #ffffff;\n  font-size: 0.95rem;\n  margin-bottom: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.footer p {\n  margin: 4px 0;\n  color: #ffffff;\n}\n\n.footer .Policy {\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n\n.footer .Policy a {\n  color: #aab8c8;\n  text-decoration: none;\n  margin: 0 8px;\n  font-weight: 600;\n  transition: color 0.2s;\n}\n\n.footer .Policy a:hover {\n  color: #4fc3a1;\n}\n\n/* ── Responsive ── */\n@media (max-width: 900px) {\n  .main-content,\n  .hero-section {\n    flex-direction: column;\n    padding: 48px 28px;\n    gap: 32px;\n  }\n\n  .main-content.alt-bg .image-content {\n    order: -1;\n  }\n\n  .text-content h1 {\n    font-size: 1.55rem;\n  }\n\n  .hero-section .text-content h1 {\n    font-size: 1.75rem;\n  }\n\n  .stats-bar {\n    flex-wrap: wrap;\n    padding: 32px 24px;\n    gap: 28px;\n  }\n\n  .frameworks-section {\n    padding: 48px 24px;\n  }\n\n  .cta-section {\n    padding: 56px 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
